module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scanner-container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [_c('video', {
    ref: "scanner",
    attrs: {
      "poster": "data:image/gif,AAAA"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "overlay-element"
  }), _vm._v(" "), _c('div', {
    staticClass: "laser"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56ad0c5e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-barcode-reader/src/components/StreamBarcodeReader.vue
// module id = 739
// module chunks = 1